export default __webpack_public_path__ + "static/media/caio-jumping.d292d416.png";